window.angular.module('common.service', []).factory('CommonService', ['$location', '$http', 'SweetAlert', '$timeout', '$rootScope', '$state', 'Gallery', 'UidService', '$translate', 'QiniuToken',
    function ($location, $http, SweetAlert, $timeout, $rootScope, $state, Gallery, UidService, $translate, QiniuToken) {
        /**
         * 封装请求后端的middleware
         * @param params
         * @param success
         * @param failure
         */
        $rootScope.requestCount = 0;
        this.request = function (params, success, failure, hideLoading, errorCodeHandler) {
            if (!hideLoading) {
                $rootScope.requestCount++;
            }
            params.header = {
                Accept: 'application/json, text/plain, */*'
            };
            try {
                $http(params).then(function (resp) {
                    if (!hideLoading) {
                        if ($rootScope.requestCount) {
                            $rootScope.requestCount--;
                        }
                    }
                    if (+resp.data.code) {
                        if (errorCodeHandler) {
                            errorCodeHandler(resp.data)
                        } else {
                            SweetAlert.swal('', resp.data.msg, 'error');
                        }
                    } else {
                        success(resp.data);
                    }
                }, function (error) {
                    if (!hideLoading) {
                        if ($rootScope.requestCount) {
                            $rootScope.requestCount--;
                        }
                    }
                    if (failure) {
                        failure(error);
                    }
                    //else {
                    //    SweetAlert.swal('', `request failed ${error.status} ${error.statusText}`, 'error');
                    //}
                })
            } catch (e) {
                console.log(e);
            }

        };


        /**
         *
         * Hack 微信中title修改不了的问题
         */
        this.setDocumentTitle = function (title) {
            document.title = title;
            if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
                var i = document.createElement('iframe');
                // i.src = '/favicon.ico';
                i.style.display = 'none';
                i.onload = function () {
                    setTimeout(function () {
                        i.remove();
                    }, 9)
                };
                document.body.appendChild(i);
            }
        };

        this.alert = function (title, text, callback, time, type) {
            SweetAlert.swal({
                title: title,
                text: text,
                imageUrl: "content/images/icons/pop_ic_msg_succeed.svg",
                timer: 2000,
                showConfirmButton: false
            });
            // SweetAlert.swal('', text, type ? type : 'success');
            $timeout(function () {
                if (callback) {
                    callback();
                }
            }, time ? time : 2000);
        };

        /**
         * 深对比对象是否相等
         */
        this.checkObjectEqual = function (origin, current) {
            var unEqual = false;
            Array.prototype.unique = function () {
                var a = this.concat();
                for (var i = 0; i < a.length; ++i) {
                    for (var j = i + 1; j < a.length; ++j) {
                        if (a[i] === a[j])
                            a.splice(j--, 1);
                    }
                }
                return a;
            };

            var checkObject = function (ori, cur) {
                if (unEqual) return;
                if (!ori || !cur) return;
                const keys1 = Object.keys(ori);
                const keys2 = Object.keys(cur);
                const keys = keys1.concat(keys2).unique();
                //console.log(keys);
                angular.forEach(keys, function (key) {
                    if (unEqual) return;
                    if (key == '$$hashKey') return;
                    if (angular.isObject(ori[key]) && angular.isObject(cur[key])) {
                        checkObject(ori[key], cur[key]);
                    } else {
                        switch (typeof ori[key]) {
                            case 'string':
                                if (ori[key].length) {
                                    unEqual = (ori[key] != cur[key]);
                                } else {
                                    unEqual = !!cur[key] || (angular.isObject(cur[key]) && Object.keys(cur[key].length));
                                }
                                break;
                            case 'number':
                                if (ori[key]) {
                                    unEqual = (ori[key] != cur[key]);
                                } else {
                                    unEqual = !!cur[key] && (cur[key] != '0');
                                }
                                break;
                            case 'object':
                                if (ori[key] == null) {
                                    unEqual = !!cur[key] || (angular.isObject(cur[key]) && Object.keys(cur[key].length));
                                } else {
                                    if (Object.keys(ori[key]).length) {
                                        unEqual = true;
                                    } else {
                                        unEqual = !!cur[key];
                                    }
                                }
                                break;
                            case 'undefined':
                                unEqual = !!cur[key] || (angular.isObject(cur[key]) && Object.keys(cur[key].length));
                                break;
                            default:
                                unEqual = (!ori[key] == !!cur[key]);
                                break;
                        }
                    }

                });
            };

            checkObject(origin, current);
            console.log(">>>>>>>>>finall--" + unEqual);
            return unEqual;

        };


        /**
         * 切换路由时检查当前是否有表单为提交
         */
        this.checkDirtyPage = function ($scope, checkFormDirty, callback) {
            $scope.$on('$stateChangeStart', function (e, toState, toParams, fromState, fromParams) {
                $('.sweet-alert').removeClass('hide-button');

                if (checkFormDirty() && !$scope.cancelCheck) {
                    e.preventDefault();
                    SweetAlert.swal({
                            title: '',
                            text: $translate.instant('confirmDialog.leavePageUnsaved'),
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonText: $translate.instant('confirmDialog.leaveAnyway'),
                            cancelButtonText: $translate.instant('button.cancel'),
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function () {
                            $scope.cancelCheck = true;
                            $state.go(toState.name, toParams);
                        });
                } else {
                    $('.sweet-alert .confirm').trigger("click");
                    $rootScope.leaveEditPage = true;
                }

            });
        };

        this.uploadFile = function (file, callback, shouldReadIMGInfo) {
            // var ext = '-' + ipCookie('userid') + '-' + parseInt(Math.random()*100000) + '.png';
            //
            // if (!this.instance) {
            //     var config = {
            //         bucket: window.diyUpyunConfig.bucket,
            //         expiration: parseInt((new Date().getTime() + 3600000) / 1000),
            //         form_api_secret: window.diyUpyunConfig.form_api_secret
            //     };
            //
            //     var instance = new Sand(config);
            //
            //     this.instance = instance;
            // }
            //
            // this.instance.upload('/upload/template/diy/' + parseInt((new Date().getTime() + 3600000) / 1000) + ext, file, function(resp) {
            //     if (!resp) {
            //         SweetAlert.swal('', "图片上传失败！没有返回值", 'error');
            //         return;
            //     }
            //     var path = imagePath+resp.path;
            //     if (shouldReadIMGInfo) {
            //         $http({url: path+"!imageInfo", method: 'get'}).then(function(resp) {
            //             if (!resp.data) {
            //                 SweetAlert.swal('', '获取图片信息失败！Sad...', 'error');
            //                 return;
            //             }
            //             var response = {
            //                 url: '' + path,
            //                 width: resp.data.width,
            //                 height: resp.data.height
            //             };
            //             if (resp.data.EXIF) {
            //                 var orientation = resp.data.EXIF.Orientation;
            //                 if (orientation == '6' || orientation == '8') {
            //                     response.width = resp.data.height;
            //                     response.height = resp.data.width;
            //                 }
            //             }
            //             callback(response);
            //         });
            //     } else {
            //         callback(path);
            //     }
            //
            // }, function(err) {
            //     console.error(err);
            //     $('.sweet-alert').removeClass('hide-button');
            //     SweetAlert.swal('', "图片上传失败，请重新上传", 'info');
            // });
        };

        // 超大图（xl 大图标识）判定阈值
        var XL_FILE_SIZE = 20971520;    // 20M
        var XL_MAX_SIDE = 30000;        // 单边像素
        var XL_MAX_PIXELS = 150000000;  // 1.5亿像素

        /**
         * 判断是否超大图（需要打 -xl 标识）：超过20M / 单边超过30000 / 超过1.5亿像素
         * width、height 不是 File 原生属性，可能调用方没赋值或异步未回填（undefined），
         * 这里统一兜底成 0，避免 undefined 参与运算导致判断失效
         */
        function isExtraLargeImage(file) {
            var size = Number(file && file.size) || 0;
            var width = Number(file && file.width) || 0;
            var height = Number(file && file.height) || 0;
            return size >= XL_FILE_SIZE
                || width > XL_MAX_SIDE
                || height > XL_MAX_SIDE
                || (width * height) > XL_MAX_PIXELS;
        }

        this.isExtraLargeImage = isExtraLargeImage;

        this.UpdateQiniuService = function (files, i, len, domain, token, folderId, aid, callback , errorcallback,detectFaces) {
            doUpdate(files, i, len, domain, token, folderId, aid, callback, errorcallback, detectFaces, false);
        };

        function doUpdate(files, i, len, domain, token, folderId, aid, callback, errorcallback, detectFaces, isRetry) {
            // width/height 不是 File 的原生属性，调用方可能没赋值或异步还没回来，
            // 这里统一兜底读取后再上传，避免 '-xl' 判断因 undefined 变成 NaN 而失效
            readImageDimensions(files[i]).then(function (dim) {
                files[i].width = dim.width;
                files[i].height = dim.height;
                runUpdate(files, i, len, domain, token, folderId, aid, callback, errorcallback, detectFaces, isRetry);
            });
        }

        function runUpdate(files, i, len, domain, token, folderId, aid, callback, errorcallback, detectFaces, isRetry) {
            var url = window.URL || window.webkitURL;
            var img = new Image();              //手动创建一个Image对象
            img.src = url.createObjectURL(files[i]);//创建Image的对象的url
            img.crossOrigin = "Anonymous";

            var formData = new FormData();

            var _key ="file-" + UidService.get()
            var fileSize = files[i].size || 0;
            var fileWidth = files[i].width || 0;
            var fileHeight = files[i].height || 0;
            var isXL = isExtraLargeImage(files[i]);
            // 超过20M / 单边超过30000 / 超过1.5亿像素 增加xl大图标识
            console.log('[upload]' + files[i].name, 'size:' + fileSize, 'width:' + fileWidth, 'height:' + fileHeight, 'isXL:' + isXL);
            if(isXL){
                _key += '-xl'
            }
            formData.append('file', files[i]);
            formData.append('key', _key);
            formData.append('token', token);

            var reader = new FileReader();
            reader.readAsArrayBuffer(files[i])
            reader.onloadend = function (e) {
                formData.append('crc32', CRC32.buf(new Uint8Array(this.result)));
                return $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: true,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        return $.ajax({
                            type: "GET",
                            url: domain + data.key + "?imageInfo",
                            success: function (va) {
                                // console.log(va)
                                if (va.orientation == "Left-bottom" || va.orientation == "Right-top") {
                                    files[i].width = va.height;
                                    files[i].height = va.width;
                                } else {
                                    files[i].width = va.width;
                                    files[i].height = va.height;
                                }
                                Gallery.upload({
                                    identifiers: data.key,
                                    detectFaces: true,
                                    provider: "QINIU",
                                    fileName: files[i].name,
                                    imgSize: files[i].size,
                                    width: files[i].width,
                                    height: files[i].height,
                                    folderId: folderId ? folderId : '',
                                    articleId: aid,
                                    hash: data.hash,
                                    detectFaces:detectFaces
                                }, function (resp) {
                                    callback.call(this, resp);
                                },function(){
                                    errorcallback.call(this, files[i]); //接口保存链接失败
                                });

                            },
                            error: function (request) {
                                errorcallback.call(this, files[i]); //接口保存链接失败
                                $(".pic-loading").addClass('hide1');
                                $(".leftPanel-bg-show").removeClass('overflow-hidden');
                            }
                        });
                    },
                    error: function (request) {
                        if (!isRetry && isTokenError(request)) {
                            // 401 / "expired token" -> 刷新token后重试一次
                            QiniuToken.refresh('get', {}, function (newToken) {
                                doUpdate(files, i, len, domain, newToken, folderId, aid, callback, errorcallback, detectFaces, true);
                            });
                            return;
                        }
                        errorcallback(files[i]);
                        $(".pic-loading").addClass('hide1');
                        $(".leftPanel-bg-show").removeClass('overflow-hidden');
                    }
                });
            }
        }

        /**
         * 获取图片文件的像素宽高（内部兜底，不依赖调用方赋值）
         * 1. 优先取调用方已挂在 file 上的 width/height
         * 2. 其次用 Image 解码
         * 3. 解码失败（超大图超出浏览器解码上限 / HEIC 等不支持的格式）时回退解析文件头二进制
         */
        function readImageDimensions(file) {
            return new Promise(function (resolve) {
                if (!file) {
                    resolve({width: 0, height: 0});
                    return;
                }
                var cachedWidth = Number(file.width);
                var cachedHeight = Number(file.height);
                if (cachedWidth > 0 && cachedHeight > 0) {
                    resolve({width: cachedWidth, height: cachedHeight});
                    return;
                }
                var urlCreator = window.URL || window.webkitURL;
                var objectUrl = null;
                try {
                    objectUrl = urlCreator.createObjectURL(file);
                } catch (e) {
                    objectUrl = null;
                }
                if (!objectUrl) {
                    readDimensionsFromHeader(file).then(resolve);
                    return;
                }
                var probeImage = new Image();
                probeImage.onload = function () {
                    urlCreator.revokeObjectURL(objectUrl);
                    var w = probeImage.naturalWidth || probeImage.width;
                    var h = probeImage.naturalHeight || probeImage.height;
                    if (w > 0 && h > 0) {
                        resolve({width: w, height: h});
                    } else {
                        readDimensionsFromHeader(file).then(resolve);
                    }
                };
                probeImage.onerror = function () {
                    urlCreator.revokeObjectURL(objectUrl);
                    readDimensionsFromHeader(file).then(resolve);
                };
                probeImage.src = objectUrl;
            });
        }

        /** 对外暴露：读取图片真实像素宽高（缓存 -> Image 解码 -> 文件头解析 三级兜底） */
        this.readImageDimensions = readImageDimensions;

        /** 通过解析图片文件头部二进制获取宽高（不需要完整解码，适用于超大图） */
        function readDimensionsFromHeader(file) {
            return new Promise(function (resolve) {
                if (!file || typeof file.slice !== 'function') {
                    resolve({width: 0, height: 0});
                    return;
                }
                var reader = new FileReader();
                reader.onload = function (e) {
                    resolve(parseImageHeader(new Uint8Array(e.target.result)));
                };
                reader.onerror = function () {
                    resolve({width: 0, height: 0});
                };
                // 只读取前64KB就足够获取大多数图片的尺寸信息
                reader.readAsArrayBuffer(file.slice(0, 65536));
            });
        }

        /** 支持 JPEG / PNG / GIF / WEBP / BMP，其它格式返回 0（由文件大小兜底判断） */
        function parseImageHeader(buffer) {
            if (!buffer || buffer.length < 24) {
                return {width: 0, height: 0};
            }
            // JPEG: FFD8 开头，找 SOF 段
            if (buffer[0] === 0xFF && buffer[1] === 0xD8) {
                var offset = 2;
                while (offset + 9 < buffer.length) {
                    if (buffer[offset] !== 0xFF) {
                        offset++;
                        continue;
                    }
                    var marker = buffer[offset + 1];
                    if (marker >= 0xC0 && marker <= 0xCF && marker !== 0xC4 && marker !== 0xC8 && marker !== 0xCC) {
                        return {
                            width: (buffer[offset + 7] << 8) | buffer[offset + 8],
                            height: (buffer[offset + 5] << 8) | buffer[offset + 6]
                        };
                    }
                    if (marker === 0x01 || (marker >= 0xD0 && marker <= 0xD9)) {
                        offset += 2;
                        continue;
                    }
                    offset += 2 + ((buffer[offset + 2] << 8) | buffer[offset + 3]);
                }
                return {width: 0, height: 0};
            }
            // PNG: 签名(8) + length(4) + IHDR(4) 之后是 4字节宽 + 4字节高（大端序）
            if (buffer[0] === 0x89 && buffer[1] === 0x50 && buffer[2] === 0x4E && buffer[3] === 0x47) {
                return {
                    width: (buffer[16] << 24) | (buffer[17] << 16) | (buffer[18] << 8) | buffer[19],
                    height: (buffer[20] << 24) | (buffer[21] << 16) | (buffer[22] << 8) | buffer[23]
                };
            }
            // GIF
            if (buffer[0] === 0x47 && buffer[1] === 0x49 && buffer[2] === 0x46) {
                return {
                    width: buffer[6] | (buffer[7] << 8),
                    height: buffer[8] | (buffer[9] << 8)
                };
            }
            // WEBP: RIFF....WEBP + chunk
            if (buffer[0] === 0x52 && buffer[1] === 0x49 && buffer[2] === 0x46 && buffer[3] === 0x46
                && buffer[8] === 0x57 && buffer[9] === 0x45 && buffer[10] === 0x42 && buffer[11] === 0x50) {
                var chunk = String.fromCharCode(buffer[12], buffer[13], buffer[14], buffer[15]);
                if (chunk === 'VP8 ') {
                    return {
                        width: (buffer[26] | (buffer[27] << 8)) & 0x3FFF,
                        height: (buffer[28] | (buffer[29] << 8)) & 0x3FFF
                    };
                }
                if (chunk === 'VP8L') {
                    var bits = buffer[21] | (buffer[22] << 8) | (buffer[23] << 16) | (buffer[24] << 24);
                    return {width: (bits & 0x3FFF) + 1, height: ((bits >>> 14) & 0x3FFF) + 1};
                }
                if (chunk === 'VP8X') {
                    return {
                        width: ((buffer[24] | (buffer[25] << 8) | (buffer[26] << 16)) >>> 0) + 1,
                        height: ((buffer[27] | (buffer[28] << 8) | (buffer[29] << 16)) >>> 0) + 1
                    };
                }
                return {width: 0, height: 0};
            }
            // HEIC / HEIF / AVIF: box 结构（size(4) + type(4)），遍历查找 ispe（图像空间尺寸）
            // Chrome 等浏览器无法解码 HEIC，只能靠解析文件头拿到宽高
            if (buffer[4] === 0x66 && buffer[5] === 0x74 && buffer[6] === 0x79 && buffer[7] === 0x70) {
                var boxPos = 0;
                var maxW = 0;
                var maxH = 0;
                while (boxPos + 8 <= buffer.length) {
                    var boxSize = ((buffer[boxPos] << 24) | (buffer[boxPos + 1] << 16) | (buffer[boxPos + 2] << 8) | buffer[boxPos + 3]) >>> 0;
                    var boxHeaderSize = 8;
                    if (boxSize === 1) { // 64位扩展长度
                        if (boxPos + 16 > buffer.length) {
                            break;
                        }
                        boxHeaderSize = 16;
                        boxSize = ((buffer[boxPos + 8] << 24) | (buffer[boxPos + 9] << 16) | (buffer[boxPos + 10] << 8) | buffer[boxPos + 11]) >>> 0;
                    }
                    if (boxSize < boxHeaderSize) {
                        break;
                    }
                    // 'ispe' -> payload: version+flags(4) + width(4) + height(4)
                    var payloadPos = boxPos + boxHeaderSize;
                    if (buffer[boxPos + 4] === 0x69 && buffer[boxPos + 5] === 0x73 && buffer[boxPos + 6] === 0x70 && buffer[boxPos + 7] === 0x65
                        && payloadPos + 12 <= buffer.length) {
                        var heicW = ((buffer[payloadPos + 4] << 24) | (buffer[payloadPos + 5] << 16) | (buffer[payloadPos + 6] << 8) | buffer[payloadPos + 7]) >>> 0;
                        var heicH = ((buffer[payloadPos + 8] << 24) | (buffer[payloadPos + 9] << 16) | (buffer[payloadPos + 10] << 8) | buffer[payloadPos + 11]) >>> 0;
                        // 可能存在多个 ispe（主图 / 缩略图），取最大的一组，避免漏判大图
                        if (heicW * heicH > maxW * maxH) {
                            maxW = heicW;
                            maxH = heicH;
                        }
                    }
                    boxPos += boxSize;
                }
                return {width: maxW, height: maxH};
            }
            // BMP
            if (buffer[0] === 0x42 && buffer[1] === 0x4D) {
                return {
                    width: (buffer[18] | (buffer[19] << 8) | (buffer[20] << 16) | (buffer[21] << 24)) >>> 0,
                    height: Math.abs((buffer[22] | (buffer[23] << 8) | (buffer[24] << 16) | (buffer[25] << 24)) | 0)
                };
            }
            return {width: 0, height: 0};
        }

        function isTokenError(request) {
            return request && (request.status === 401 ||
                (request.responseText && request.responseText.indexOf('expired token') !== -1));
        }

        return this;

    }]);
